import React, { useEffect, useMemo, useState } from 'react';
import {
  Card,
  Grid,
  CardContent,
  Typography,
  Box,
  TextField,
  IconButton,
  Alert,
} from '@mui/material';

import Thumbnail from 'src/modules/lms/components/LMSSession/Thumbnail';
import { Spacer } from 'src/components/shared';
import { useStyles, StyledSearchIcon } from '../Recruitement/styles';
import CloseIcon from '@mui/icons-material/Close';
import { useHomeProvider } from '../../utils/homeStore';

function Home({ sessions, loading, categoryType }) {
  const classes = useStyles();
  const [inputHide, setInputHide] = React.useState('none');
  const [iconHide, setIconHide] = React.useState('block');

  const [data, setData] = useState(sessions);
  const [searchKeyword, setSearchData] = React.useState('');

  const { filters } = useHomeProvider();

  const emptyString = useMemo(() => {
    try {
      if (data && data.length) return '';
      else if (filters.experts || filters.tags) {
        let str = '';
        str +=
          filters.experts && filters.experts.length
            ? filters.experts.map((item) => `'${item.name}'`).join(' ')
            : '';
        str += ' ';
        str +=
          filters.tags && filters.tags.length
            ? filters.tags.map((item) => `'${item.name}'`).join(' ')
            : '';
        return str;
      }
      return '';
    } catch (err) {
      console.log('err : ', err);
    }
  }, [data, filters]);

  const InputField = () => {
    setInputHide('block');
    setIconHide('hidden');
  };

  useEffect(() => {
    setData(sessions);
  }, [sessions]);

  const handleKeyupSearch = (evt) => {
    let searchValue = evt.target.value;
    if (searchValue && searchValue !== '') {
      setSearchData(searchValue);
      let filteredData = [];
      if (!searchValue) {
        filteredData = sessions;
      } else {
        filteredData = sessions?.filter((item) => {
          return item?.title.toLowerCase().includes(searchValue.toLowerCase());
        });
      }
      // setData(filteredData);
    }
  };
  const onClose = (evt) => {
    let searchValue = evt.target.value;
    setSearchData(searchValue);
    let filteredData = [];
    if (!searchValue) {
      filteredData = sessions;
    } else {
      filteredData = sessions?.filter((item) => {
        return item?.title.toLowerCase().includes(searchValue.toLowerCase());
      });
    }
    // setData(filteredData);
    setSearchData('');
    handleKeyupSearch;
  };
  if (loading) return null;

  return (
    <>
      <Card>
        <CardContent sx={{ backgroundColor: '#0C1721', padding: '24px' }}>
          <Box display={'flex'} justifyContent={'space-between'}>
            <Typography color="secondary" variant="h2">
              The Sessions
            </Typography>
          </Box>
          <Spacer x={2} y={2} />
          {data && data.length ? (
            <Grid container spacing={2}>
              {data?.map((session, index) => (
                <Grid key={index} item md={3} xs={6}>
                  <Thumbnail session={session} categoryType={categoryType} />
                </Grid>
              ))}
              <Grid item xs={3}></Grid>
            </Grid>
          ) : (
            <Alert
              severity="error"
              variant="standard"
              sx={{
                background: '#EF5350',
                justifyContent: 'center',
                color: '#ffffff',
                '& .MuiSvgIcon-root': {
                  fill: '#ffffff',
                },
              }}
            >
              {emptyString !== '' ? (
                <span>
                  Oh no! We can't find a match for <b>{emptyString}</b>
                </span>
              ) : (
                <span>No sessions found.</span>
              )}
            </Alert>
          )}
        </CardContent>
      </Card>
    </>
  );
  return <div>Home</div>;
}

export default Home;
